<button type="button"
  id="zoomIn"
  class="toolbarButton zoomIn"
  title="Zoom In"
  data-l10n-id="zoom_in">
  <span data-l10n-id="zoom_in_label">Zoom In</span>
</button>
